import { render, staticRenderFns } from "./AddForm.vue?vue&type=template&id=91e943e8&lang=pug&"
import script from "./AddForm.vue?vue&type=script&lang=ts&"
export * from "./AddForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports